/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { hasUTRVFilter } from '../utils/getDisableUtrs';
import { ScopeView, ScopeViewDropdown } from './partials/ScopeViewDropdown';
import { Spacer } from './partials/Spacer';
import { FilterQuestionsToggle } from './partials/FilterQuestionsToggle';
import { SearchQuestions } from './partials/SearchQuestions';
import { SurveySettings } from '../../../types/survey';
import { FilterQuestions } from './partials/FilterQuestions';
import './styles.scss';
import { SurveyOverviewMode } from '../../../slice/surveySettings';
import { Scope } from '../../../model/surveyData';

type ToolbarComponent = (props: ToolbarComponentCommonProps<Partial<SurveySettings>>) => JSX.Element | null;

export interface SurveyQuestionListToolbarProps<Settings extends Partial<SurveySettings> = Partial<SurveySettings>> {
  surveyId?: string;
  initiativeId: string;
  handleChangeSettings?: (key: keyof Settings, setting: string | string[] | boolean) => void;
  settings?: Settings;
  components?: (ToolbarComponent | null)[];
  toggleExpandAll: () => void;
  isExpanded: boolean;
  toggleSelectAll: () => void;
  isSelectAll: boolean;
  toggleShowingBookmarks?: (hasFilterByBookmarks: boolean) => void;
  isShowingBookmarks?: boolean;
  defaultOverviewMode?: SurveyOverviewMode;
  handleSelectOverviewMode?: (view: ScopeView) => void;
  surveyScope: Scope | undefined;
}

export interface ToolbarComponentCommonProps<Settings extends Partial<SurveySettings> = Partial<SurveySettings>> extends SurveyQuestionListToolbarProps<Settings> {
  toggleFilters: () => void;
}

const defaultComponents: ToolbarComponent[] = [
  ScopeViewDropdown,
  Spacer,
  SearchQuestions,
  FilterQuestionsToggle
]

export const SurveyQuestionListToolbar = (props: SurveyQuestionListToolbarProps) => {
  const { settings, handleChangeSettings, components = defaultComponents, surveyScope, initiativeId } = props;

  const [showFilters, setShowFilters] = useState(settings ? hasUTRVFilter(settings) : false);

  const toggleFilters = () => setShowFilters(!showFilters);

  const toolbarProps = {
    ...props,
    toggleFilters
  };

  return (
    <>
      <div className='surveyQuestionListToolbar d-flex align-items-center'>

        {components.map(
          (el, ix) => el ? React.createElement(el, { ...toolbarProps, key: `cp-${ix}` }) : null
        )}

      </div>
      {showFilters && settings && handleChangeSettings ?
        <div className='py-3'>
          <FilterQuestions
            initiativeId={initiativeId}
            settings={settings}
            handleChangeSettings={handleChangeSettings}
            surveyScope={surveyScope}
          />
        </div>
        : null}
    </>
  );
}
